module.exports = __webpack_public_path__ + "img/IMG_058-thumb-510x363-1106.e90a84de.png";